import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=048580a0&scoped=true&"
import script from "./showDetail.vue?vue&type=script&lang=ts&"
export * from "./showDetail.vue?vue&type=script&lang=ts&"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=048580a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048580a0",
  null
  
)

export default component.exports